/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Edit_CategoryInputs */

const en_cases_settings_edit_category = /** @type {(inputs: Cases_Settings_Edit_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit category`)
};

/**
* | output |
* | --- |
* | "Edit category" |
*
* @param {Cases_Settings_Edit_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cases_settings_edit_category = /** @type {((inputs?: Cases_Settings_Edit_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Edit_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_edit_category(inputs)
});